// extracted by mini-css-extract-plugin
module.exports = {"renderTitle":"style_renderTitle__xUipz","title":"style_title__2k2eZ","objectPermissionModal":"style_objectPermissionModal__3m3VZ"};